module.exports = __webpack_public_path__ + "images/dropdown-09721370.svg";